import { TRelationMedecin } from "../types/relation";
import { appRequest } from "./services";

const getReturnedData = (dataRes: any) => {
    return {
        id: dataRes.id,
        documentId: dataRes.documentId,
        horaires_injection: dataRes.horaires_injection,
        medecin: {
            id: dataRes.medecin?.id,
            uid: dataRes.medecin?.uid,
            nom: dataRes.medecin?.nom,
            prenom: dataRes.medecin?.prenom,
        },
        cabinet: {
            id: dataRes.cabinet?.id,
            uid: dataRes.cabinet?.uid,
            nom: dataRes.cabinet?.nom,
        },
        user: {
            id: dataRes.user?.id,
        },
        piece_compte_rendu: dataRes.piece_compte_rendu,
        piece_courrier_medecin: dataRes.piece_courrier_medecin,
        piece_last_oct: dataRes.piece_last_oct,
        piece_poss_prod_injec: dataRes.piece_poss_prod_injec,
        solution_resa: dataRes.solution_resa,
        solution_resa_alaxione: dataRes.solution_resa_alaxione,
        solution_resa_custom: dataRes.solution_resa_custom,
        solution_resa_doctolib: dataRes.solution_resa_doctolib,
        solution_resa_tel: dataRes.solution_resa_tel,
    } as TRelationMedecin;
};

export const listRelationByMedecin = async (tIdMedecin: Array<number>) => {
    let tFilter = "";

    tIdMedecin.forEach((item, key) => {
        tFilter += `&filters[$or][${key}][medecin][id][$eq]=${item}`;
    });

    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        url: `relation-medecin-cabinets?populate=*&filters[cabinet][status][$eq]=published${tFilter}`,
    });

    return currentRequest.data.data.map((item) => {
        return getReturnedData(item);
    }) as Array<TRelationMedecin>;
};

export const listRelationByCabinet = async (id_cabinet: number) => {
    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        url: `relation-medecin-cabinets?populate=*&filters[cabinet][status][$eq]=published&filters[cabinet][id][$eq]=${id_cabinet}`,
    });

    return currentRequest.data.data.map((item) => {
        return getReturnedData(item);
    }) as Array<TRelationMedecin>;
};

export const getRelationByCabinetMedecin = async (
    id_cabinet: number,
    id_medecin: number
) => {
    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        url: `relation-medecin-cabinets?populate=*&filters[cabinet][status][$eq]=published&filters[$and][0][cabinet][id][$eq]=${id_cabinet}&filters[$and][1][medecin][id][$eq]=${id_medecin}`,
    });

    return currentRequest.data.data.map((item) => {
        return getReturnedData(item);
    }) as Array<TRelationMedecin>;
};

export const insertNewRelation = async (data: {
    medecin: number;
    cabinet: number;
    user: number;
    horaires_injection: string;
}) => {
    const currentRequest = await appRequest<{
        data: any;
    }>({
        url: `relation-medecin-cabinets?populate=*`,
        method: "POST",
        data: {
            data,
        },
    });
    const dataRes = currentRequest.data.data;
    return getReturnedData(dataRes) as TRelationMedecin;
};

export const updateRelation = async (data: any) => {
    const docId = data.id;
    delete data.id;
    const currentRequest = await appRequest<{
        data: any;
    }>({
        url: `relation-medecin-cabinets/${docId}?populate=*`,
        method: "PUT",
        data: {
            data,
        },
    });
    const dataRes = currentRequest.data.data;
    return getReturnedData(dataRes) as TRelationMedecin;
};

export const deleteRelation = async (idRelation: string) => {
    const currentRequest = await appRequest<{
        data: any;
    }>({
        url: `relation-medecin-cabinets/${idRelation}`,
        method: "DELETE",
    });
    return currentRequest.data.data;
}
